import React from 'react';
import { Link, withRouter, NavLink } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
 
class Navigation extends React.Component {

    state = {
        collapsed: true,
        isOpen: false
    };

    toggleNavbar = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

    componentDidUpdate(nextProps) {
        if (this.props.match.path !== nextProps.match.path) {
            // this.onRouteChanged();
            console.log('OK')
        }
    }

    onRouteChanged = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    render(){
        const { collapsed } = this.state;
        const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
        const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';
        const menuClass = `dropdown-menu${this.state.isOpen ? " show" : ""}`;
        return (
            <header id="header" className="header-area">
                <div id="navbar" className="elkevent-nav">
                    <nav className="navbar navbar-expand-md navbar-light">
                        <div className="container">
                            <Link className="navbar-brand" to="/">
                                <img src={logo} alt="logo" />
                                <span >Educación orgánica </span>    
                            </Link>

                            <button 
                                onClick={this.toggleNavbar} 
                                className={classTwo}
                                type="button" 
                                data-toggle="collapse" 
                                data-target="#navbarSupportedContent" 
                                aria-controls="navbarSupportedContent" 
                                aria-expanded="false" 
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <div className={classOne} id="navbarSupportedContent">
                                <ul className="navbar-nav ms-auto">
                                    <li className="nav-item">
                                        <NavLink 
                                            to="/horario" 
                                            className="nav-link" 
                                            onClick={this.toggleNavbar}
                                        >
                                            Horario
                                        </NavLink>
                                    </li>
                                    
                                    <li className="nav-item">
                                        <NavLink 
                                            to="/ponentes" 
                                            className="nav-link" 
                                            onClick={this.toggleNavbar}
                                        >
                                            Ponentes
                                        </NavLink>
                                    </li>

                                    <li className="nav-item">
                                        <NavLink 
                                            to="/talleres" 
                                            className="nav-link" 
                                            onClick={this.toggleNavbar}
                                        >
                                            Talleres
                                        </NavLink>
                                    </li>

                                    <li className="nav-item">
                                        <NavLink 
                                            to="/patrocinadores" 
                                            className="nav-link" 
                                            onClick={this.toggleNavbar}
                                        >
                                            Patrocinadores
                                        </NavLink>
                                    </li>

                                </ul>

                                <div className="others-option">
                                    <ul>
                                        <li>
                                            <NavLink 
                                                to="/inscripcion" 
                                                className="btn btn-primary" 
                                                onClick={this.toggleNavbar}
                                            >
                                                Inscripción
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        );
    }
}
 
export default withRouter(Navigation);